export function errorAlert(error: any) {
  alert(error?.response?.data?.detail ?? error?.response?.data?.message ?? String(error));
}
